<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Status/Nível divergente entre as bases"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [extraButton]="true"
  (extraButtonClick)="syncTableElements()"
  extraLabel="Sincronizar Tabela"
  [service]="bfluenceIntegrityService"
  pageFunctionName="getDivergentBfluencerStatusCheckTable"
  emptyMessage="Sem mais bfluencers desatualizadas no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="registros"
  [defaultRows]="10"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
